<template>
	<div class="page">
		<div class="form">
			<div class="pageTitleBox">
				<div class="boxNameL">
					新建会员
				</div>
				<div class="boxNameR">
					<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
				</div>
			</div>
			<div class="tit">
				<div class="titL">基本信息</div>
				<div class="titR"></div>
			</div>
			<div class="con">
				<el-form :inline="true" :model="form" class="demo-form-inline" ref="form" label-width="formLabelWidth" :rules="rules">
					<el-row>
						<el-col :span="7" :offset="1">
							<el-form-item label="姓名：" :label-width="formLabelWidth" prop="nick_name">
								<el-input v-model="form.nick_name" placeholder="请输入姓名"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="7">
							<el-form-item label="生日：" :label-width="formLabelWidth" prop="birthday">
								<el-date-picker v-model="form.birthday" type="date" placeholder="选择日期" @change="changeDate">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="7">
							<el-form-item label="年龄：" :label-width="formLabelWidth" prop="age">
								<el-input :value="$public.FAge(form.birthday)[0]" disabled placeholder="请输入年龄"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="7" :offset="1">
							<el-form-item label="手机号码：" :label-width="formLabelWidth" prop="user_mobile">
								<el-input v-model="form.user_mobile" placeholder="请输入手机号码"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="7">
							<el-form-item label="性别：" :label-width="formLabelWidth" prop="sex">
								<el-radio-group v-model="form.sex">
									<el-radio :label="'男'">男</el-radio>
									<el-radio :label="'女'">女</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="7">
							<el-form-item label="邮箱：" :label-width="formLabelWidth" prop="user_email">
								<el-input v-model="form.user_email" placeholder="请输入邮箱"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- <el-row>
						<el-col :span="7" :offset="1">
							<el-form-item label="会员类型：" :label-width="formLabelWidth" prop="user_type">
								<el-radio-group v-model="form.user_type">
									<el-radio :label="0">普通会员</el-radio>
									<el-radio :label="1">充值会员</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row> -->
					<el-row>
						<el-col :span="7" :offset="1">
							<el-form-item label="家庭住址：" :label-width="formLabelWidth" prop="home_address">
								<el-input type="textarea" rows="3" v-model="form.home_address" placeholder="请输入家庭住址"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6" :offset="1">
							<el-form-item label="年龄区间" :label-width="formLabelWidth" prop="age_group">
								<el-select v-model="age_group" placeholder="请选择" @change="age">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6" :offset="1">
						<el-form-item label="客户来源" :label-width="formLabelWidth" prop="user_source">
								<el-select v-model="user_source" placeholder="请选择" @change="source">
									<el-option v-for="item in option" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<el-row style="padding:80px;">
				<el-button type="primary" @click="submit">保存</el-button>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			var validateTel = (rule, value, callback) => {
				if (!this.$public.isTel(value)) {
					callback(new Error('手机号输入有误'));
				} else {
					callback();
				}
			};
			var isMail = (rule, value, callback) => {
				if(value==''){
					callback();
				}else 
				if (!this.$public.isMail(value)) {
					callback(new Error('邮箱输入有误'));
				} else {
					callback();
				}
			};
			return {
				options: [{
          value: '18-25',
          label: '18-25'
        }, {
          value: '25-30',
          label: '25-30'
        }, {
          value: '30-35',
          label: '30-35'
        }, {
          value: '35-40',
          label: '35-40'
        }, {
          value: '45-50',
          label: '45-50'
        }, {
          value: '50-1000',
          label: '50以上'
        }],
        age_group: '',
		user_source:'',//客户来源
		option: [{
          value: '自然流量',
          label: '自然流量'
        }, {
          value: '宠物广告',
          label: '宠物广告'
        }, {
          value: '抖音',
          label: '抖音'
        }, {
          value: '小红书',
          label: '小红书'
        }, {
          value: '团购',
          label: '团购'
        },{
          value: '官方直播',
          label: '官方直播'
        },{
          value: '其它',
          label: '其它'
        },
	],
				form: {
					"user_mobile": "",
					"nick_name": "",
					"avatar_pic": "",
					"user_email": "",
					"user_address": "",
					"home_address": "",
					"sex": "女",
					"birthday": "",
					"user_type": 0,
					age_group:[],
					user_source:''
				},
			
				formLabelWidth: '120px',
				rules: {
					nick_name: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					user_mobile: [{
						required: true,
						validator: validateTel,
						trigger: 'blur'
					}],
					user_email: [{
						validator:isMail,
						trigger: 'blur'
					}],
					home_address: [{
						message: '请输入地址',
						trigger: 'blur'
					}],
					age_group: [{
					required: true,
					message: '请选择年龄区间',
					trigger: 'blur'
				}],
				user_source: [{
					required: true,
					message: '请选择客户来源',
					trigger: 'blur'
				}],
					// sex: [{required: true,message: '请选择会员类型',trigger: 'change'}],
				}
			}
		},
		mounted() {

		},
		methods: {
			age(e){
           console.log(e,"eeeeeeeee");
		   this.form.age_group=e.split("-")
		},
		source(e){
		
		this.form.user_source=e
		console.log(this.form.user_source,"eeeeeeeee");
	},
		
			// 修改生日
			changeDate(a) {
				if (a == null) {
					this.form.birthday = '';
				} else {
					this.form.birthday = new Date(a).getTime();
				}
			},
			// 提交用户信息
			submit() {
			// 	if (this.value== []) {
			// 	this.$message({
			// 		type: "error",
			// 		message: "顾客年龄区间不完整",
			// 	});
			// 	return;
			// }
				this.$refs['form'].validate((valid) => {
					if (valid) {
						let loading = this.$loading();
						let params = {
							"user_mobile": this.form.user_mobile,
							"nick_name": this.form.nick_name,
							"avatar_pic": '',
							"user_email": this.form.user_email,
							"user_address": this.form.user_address,
							"home_address": this.form.home_address,
							"sex": this.form.sex,
							"birthday": this.$public.FTime(new Date(this.form.birthday).getTime(),'YYYY-MM-DD'),
							"user_type": this.form.user_type,
							age_group:this.form.age_group,
							user_source:this.form.user_source
						}
						console.log(params,"params123");
						this.$http.post('/api/Member/Insert', params).then(res => {
							if (res.code == 0) {
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.form = {
									"user_mobile": "",
									"nick_name": "",
									"avatar_pic": "",
									"user_email": "",
									"user_address": "",
									"home_address": "",
									"sex": "",
									"birthday": "",
									"user_type": 0,
									age_group:[],
									user_source:''
								}
								loading.close()
								this.$router.replace({path:'/huiyuan/huiyuanSee',query:{id:res.data,tab:2}})
							}
							loading.close()
						})
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		.form {
			.tit {
				display: flex;
				justify-content: space-between;
				padding-bottom: 20px;

				.titL {
					font-size: 20px;
					color: #1A1A1A;
					border-left: 3px solid #FFD138;
					padding-left: 10px;
					line-height: 24px;
					height: 24px;
				}

				.titR {}
			}

			.con {
				padding-bottom: 30px;
			}
		}
	}
</style>
